import {
  ReactElement,
  ChangeEvent,
  useState,
  useCallback,
  useEffect,
  useMemo,
} from 'react';
import { FormControlLabel, Checkbox } from '@mui/material';

import { DialogConfirmDeleteRouteProps } from './types';
import DialogConfimation from '../DialogConfimation';

const initialRemoveItems = false;

const warningTextRoute = `Esta acción eliminará de forma permanente la ruta, su progreso,
  historial y todos los registros de visita. Los pedidos relacionados
  volverán a estado pendiente en caso de no seleccionar la siguiente
  casilla`;

const warningTextTemplate = `Esta acción eliminará de forma permanente la plantilla.
  Los pedidos relacionados volverán a estado pendiente en caso de no seleccionar la siguiente
  casilla`;

const DialogConfirmDeleteRoute = ({
  open,
  onConfirm,
  onCancel,
  loadingConfirm = false,
  routeCode,
  type = 'route',
}: DialogConfirmDeleteRouteProps): ReactElement => {
  const isTemplate = useMemo(() => type === 'template', [type]);

  const description = useMemo(() => {
    const prefix = isTemplate ? 'plantilla' : 'ruta';

    return `La ${prefix} #${routeCode?.toUpperCase()} será eliminada`;
  }, [isTemplate, routeCode]);

  const warningText = useMemo(
    () => (isTemplate ? warningTextTemplate : warningTextRoute),
    [isTemplate],
  );

  const [removeItems, setRemoveItems] = useState(initialRemoveItems);

  const handleChangeRemoveItems = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setRemoveItems(event.target.checked);
    },
    [],
  );

  const handleConfirm = useCallback(() => {
    onConfirm(removeItems);
  }, [onConfirm, removeItems]);

  useEffect(() => {
    if (!open) {
      setRemoveItems(initialRemoveItems);
    }
  }, [open]);

  return (
    <DialogConfimation
      open={open}
      description={description}
      warningText={warningText}
      onConfirm={handleConfirm}
      onCancel={onCancel}
      loadingConfirm={loadingConfirm}
    >
      <FormControlLabel
        control={
          <Checkbox
            checked={removeItems}
            onChange={handleChangeRemoveItems}
            size="small"
          />
        }
        label="Eliminar pedidos relacionados"
      />
    </DialogConfimation>
  );
};

export default DialogConfirmDeleteRoute;
